module.exports = __webpack_public_path__ + "media/src/img/pay_cash-00e64956cb3fdc2c7dec0a3945c05f4b.jpg";